<script lang="ts">
  import { hasPrevPage } from "../../lib/stores/session";
  import DefaultArtwork from "../DefaultArtwork.svelte";
  import { routeChangeHandler } from "../../lib/helpers/router";
  import { sessionStore } from "../../lib/stores/session";
  import { modeStore } from "../../lib/stores/mode";
  import LoadingScreen from "../LoadingScreen.svelte";
  import { getStepNumberAndTotal } from "../../lib/stores/pageProgress";
  import BackButton from "../BackButton.svelte";
  import { onMount } from "svelte";
  import Captcha from "../Captcha.svelte";

  export let showBackButton = true;
  export let currentRoute: { name: string };
  export let hideMobileArtwork = false;
  export let customBackHandler: (() => void) | null = null;

  onMount(() => document.body.scrollIntoView({ behavior: "smooth" }));

  $: requiresAuth = $sessionStore.routes.find((route) => route.path === currentRoute.name)?.requiresAuth ?? false;
  $: void routeChangeHandler(currentRoute.name);
</script>

<Captcha route={currentRoute.name} />
<div
  class="flex flex-col p-4 lg:px-14 pt-0 pb-0 lg:justify-between lg:flex-row-reverse lg:mt-[1.1875rem] mb-[2.3125rem] gap-6"
  class:mt-2.5={!$getStepNumberAndTotal?.stepNumber}
  class:mt-12={$getStepNumberAndTotal?.stepNumber}>
  <div
    class="lg:flex justify-start w-full items-start lg:sticky lg:h-full lg:top-24"
    class:hidden={hideMobileArtwork}>
    <div class="flex w-full lg:h-[80vh] lg:max-h-[initial]">
      <slot name="artwork">
        <DefaultArtwork />
      </slot>
    </div>
  </div>
  <div class="min-w-[45%] mb-20 flex w-full gap-2 lg:pt-4 lg:w-[calc(100%-640px-116px)]">
    <BackButton {customBackHandler} isVisible={showBackButton} />

    <div
      class="w-full flex flex-col lg:pt-24 lg:h-full lg:max-w-[45rem]"
      class:lg:pl-20={!showBackButton || !($hasPrevPage || customBackHandler)}>
      {#if !requiresAuth || $sessionStore.jwt || ["demo", "editor"].includes($modeStore.mode)}
        <slot name="content"></slot>
      {:else}
        <LoadingScreen />
      {/if}
    </div>
  </div>
</div>
